<template>
<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_55605_706)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 1H33V33H1V1Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 11.6687H33V33H1V11.6687Z" fill="#0039A6"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 22.3313H33V33H1V22.3313Z" fill="#D52B1E"/>
</g>
<rect x="0.5" y="0.5" width="33" height="33" rx="16.5" stroke="#F0F0F0"/>
<defs>
<clipPath id="clip0_55605_706">
<rect x="1" y="1" width="32" height="32" rx="16" fill="white"/>
</clipPath>
</defs>
</svg>

</template>